import { c as _c } from "react/compiler-runtime";
import Practicals from '@/components/modules/Practicals';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { BBookableTypeEnum } from '@/types/backend';
const ExperiencePracticals = t0 => {
    const $ = _c(16);
    const { reducedSectionWidth, innerClassName: t1, experience } = t0;
    const innerClassName = t1 === undefined ? "" : t1;
    const translate = useTranslate();
    let t2;
    if ($[0] !== experience.type || $[1] !== translate) {
        t2 = translate("experience_page.description.title", {
            experienceType: experience.type
        });
        $[0] = experience.type;
        $[1] = translate;
        $[2] = t2;
    }
    else {
        t2 = $[2];
    }
    const descriptionTitle = t2;
    const isMeal = experience.type === BBookableTypeEnum.Meal;
    const mealConfiguration = isMeal && "configuration" in experience ? experience.configuration : undefined;
    const mealContent = isMeal ? experience.content : undefined;
    const t3 = `experience.type.${experience.type}`;
    let t4;
    if ($[3] !== t3 || $[4] !== translate) {
        t4 = translate(t3, {
            count: 1
        });
        $[3] = t3;
        $[4] = translate;
        $[5] = t4;
    }
    else {
        t4 = $[5];
    }
    const navLabel = t4;
    const t5 = experience;
    let t6;
    if ($[6] !== descriptionTitle || $[7] !== experience.informations || $[8] !== experience.type || $[9] !== innerClassName || $[10] !== mealConfiguration || $[11] !== mealContent || $[12] !== navLabel || $[13] !== reducedSectionWidth || $[14] !== t5.description) {
        t6 = <><Practicals descriptionTitle={descriptionTitle} description={t5.description} mealConfiguration={mealConfiguration} mealContent={mealContent} type={experience.type} informations={experience.informations} reducedSectionWidth={reducedSectionWidth} innerClassName={innerClassName} data-nav-label={navLabel}/></>;
        $[6] = descriptionTitle;
        $[7] = experience.informations;
        $[8] = experience.type;
        $[9] = innerClassName;
        $[10] = mealConfiguration;
        $[11] = mealContent;
        $[12] = navLabel;
        $[13] = reducedSectionWidth;
        $[14] = t5.description;
        $[15] = t6;
    }
    else {
        t6 = $[15];
    }
    return t6;
};
export default ExperiencePracticals;
